import _ from 'lodash'

import {
  LIST_USERS_STARTED,
  LIST_USERS_COMPLETED,
  LIST_USERS_FAILED,
  CLEAR_STATES
} from '@/store/types'
import { marshalUser } from '@/utils/marshal'

import createUserForm from './users_list/create_user_form'

import { ITEM_PER_PAGE_FOR_PLACEHOLDER } from '@/config'

function getDefaultState () {
  return {
    users: [],
    prevPageToken: '',
    nextPageToken: '',
    totalItems: -1,

    loading: false,
    error: undefined,
    actionError: undefined
  }
}

export default {
  namespaced: true,
  modules: {
    createUserForm
  },

  state: getDefaultState(),
  getters: {},

  mutations: {
    // List users
    [LIST_USERS_STARTED] (state) {
      state.loading = true
      // Provide empty object to show loading content
      state.users = new Array(ITEM_PER_PAGE_FOR_PLACEHOLDER).fill({})
    },
    [LIST_USERS_COMPLETED] (state, payload) {
      const { users } = payload
      state.users = users.users.map(marshalUser)
      state.prevPageToken = _.cloneDeep(users.previous_page_token)
      state.nextPageToken = _.cloneDeep(users.next_page_token)
      state.totalItems = users.total_size

      state.loading = false
      state.error = undefined
    },
    [LIST_USERS_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async list ({ commit, rootState: { client = undefined } }, payload) {
      const { rowsPerPage, pageToken, ascending, sortKey, queryKey, queryValue } = payload
      try {
        commit(LIST_USERS_STARTED)
        const usersObj = await client.managementClient.listUsers(rowsPerPage, pageToken, ascending, sortKey, queryKey, queryValue)
        commit(LIST_USERS_COMPLETED, {
          users: usersObj,
          ascending: ascending
        })
      } catch (err) {
        commit(LIST_USERS_FAILED, err)
      }
    }
  }
}
